import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import { Tab, Tabs } from 'react-bootstrap';
import { OpenAPI, ContentMessage } from 'axway-react-ui';

class ImportSummaryView extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.renderSummaryTab = this.renderSummaryTab.bind(this);
	}

	renderSummaryTab() {
		const { specType, importedSpec } = this.props;
		if (specType === 'endpoint' || specType === 'openapi') {
			return (
				<Tab
					eventKey={0}
					title={this.intl.formatMsg('Summary')}
				>
					<OpenAPI
						spec={importedSpec}
						showInfo
						// disable try-it
						supportedSubmitMethods={[ '' ]}
					/>
				</Tab>
			);
		} else {
			return (
				<Tab
					eventKey={0}
					title={this.intl.formatMsg('Summary')}
				>
					<ContentMessage
						detail={this.intl.formatMsg('Not supported specification.')}
						imgClass="gg icon-GG-empty-list"
						className="sm empty"
						inlineContent
					/>
				</Tab>
			);
		}
	}

	render() {
		return (
			<div className="import-summary-view">
				<Tabs
					id="import-summary-tabs"
					className="axui"
					animation={false}
				>
					{this.renderSummaryTab()}
				</Tabs>
			</div>
		);
	}
}

ImportSummaryView.propTypes = {
	/**
	 * Imported API spec definition (parsed)
	 */
	importedSpec: PropTypes.any.isRequired,

	/**
	 * The specification type.
	 */
	specType: PropTypes.string.isRequired
};

export default injectIntl(ImportSummaryView);
